/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { html, CSSResultArray, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { styles } from './nile-side-bar-footer.css';
import NileElement from '../internal/nile-element';

/**
 * Nile side-bar-footer component.
 *
 * @tag nile-side-bar-footer
 *
 * @slot icon - Slot for footer icon
 * @slot text - Slot for footer text
 */
@customElement('nile-side-bar-footer')
export class NileSideBarFooter extends NileElement {
  public static get styles(): CSSResultArray {
    return [styles];
  }

  public render(): TemplateResult {
    return html`
      <div part="base" class="footer">
      <slot> </slot>
      </div>
    `;
  }
}

export default NileSideBarFooter;

declare global {
  interface HTMLElementTagNameMap {
    'nile-side-bar-footer': NileSideBarFooter;
  }
}
